module.exports = __webpack_public_path__ + "static/media/permissions.c10063f0.mp4";